import { lazy } from 'react';
const Home = lazy(() => import('./views/Home/Home'));
const Login = lazy(() => import('./views/Login/Login'));
const Register = lazy(() => import('./views/Register/Register'));
const Journal = lazy(() => import('./views/Journal/Journal'));
// const NotFound = lazy(() => import("./views/NotFound"));

const Routes = [
  {
    slug: '/',
    component: Home,
  },
  {
    slug: '/login',
    component: Login,
  },
  {
    slug: '/register',
    component: Register,
  },
  {
    slug: '/write',
    component: Journal,
    requireAuth: true,
  },
  //   {
  //     slug: "*",
  //     component: NotFound,
  //   },
];

export default Routes;
